import { render } from "./OfferConfigurations.vue?vue&type=template&id=4f5c9d27&scoped=true"
import script from "./OfferConfigurations.vue?vue&type=script&lang=js"
export * from "./OfferConfigurations.vue?vue&type=script&lang=js"

import "./OfferConfigurations.vue?vue&type=style&index=0&id=4f5c9d27&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5c9d27"]])

export default __exports__